import React, { createContext, useContext, useEffect, useState } from 'react';
import api from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not logged in
  const [rate, setRate] = useState(null);
  const [rateNotice, setRateNotice] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('vcard_token');
    const cached = localStorage.getItem('vcard_user');
    if (!token) {
      setUser(null);
      return;
    }
    if (cached) {
      try {
        setUser(JSON.parse(cached));
      } catch (err) {
        console.warn('Cached user parse failed:', err);
      }
    }
    api.get('/auth/me').then((r) => {
      setUser(r.data);
      localStorage.setItem('vcard_user', JSON.stringify(r.data));
    }).catch(() => {
      setUser(null);
      localStorage.removeItem('vcard_token');
      localStorage.removeItem('vcard_user');
    });
  }, []);

  // Poll cost rate every 30 seconds when logged in
  useEffect(() => {
    if (!user) return;
    let lastRate = null;
    const fetchRate = async () => {
      try {
        const r = await api.get('/rate');
        if (lastRate !== null && lastRate !== r.data.cost_rate && user.role === 'employee') {
          setRateNotice({ from: lastRate, to: r.data.cost_rate });
          setTimeout(() => setRateNotice(null), 8000);
        }
        lastRate = r.data.cost_rate;
        setRate(r.data);
      } catch (err) {
        console.warn('Rate fetch failed:', err);
      }
    };
    fetchRate();
    const id = setInterval(fetchRate, 30000);
    return () => clearInterval(id);
  }, [user]);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('vcard_token', r.data.token);
    localStorage.setItem('vcard_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (err) {
      console.warn('Logout API call failed:', err);
    }
    localStorage.removeItem('vcard_token');
    localStorage.removeItem('vcard_user');
    setUser(null);
  };

  const updateProfile = async (payload) => {
    const r = await api.put('/auth/me', payload);
    if (r.data.changed) {
      localStorage.setItem('vcard_token', r.data.token);
      localStorage.setItem('vcard_user', JSON.stringify(r.data.user));
      setUser(r.data.user);
    }
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, updateProfile, rate, setRate, rateNotice, setRateNotice }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
